var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurchase = function SvgPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "inherit"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    y: 0.5,
    rx: 7.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.924 7.183a1.53 1.53 0 0 0-1.55-1.475H5.983c-.844 0-1.522.65-1.55 1.475l-.141 3.722v.046c0 .843.696 1.53 1.549 1.53h3.726c.408 0 .802-.178 1.09-.485.29-.316.436-.706.413-1.096l-.142-3.717zm-.715.014.142 3.713a.86.86 0 0 1-.225.582.75.75 0 0 1-.56.256H5.842a.806.806 0 0 1-.812-.793l.143-3.762a.797.797 0 0 1 .747-.752h3.483c.45 0 .788.316.811.756z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.679 8.971c.999 0 1.783-.775 1.783-1.76a.35.35 0 0 0-.106-.261c-.133-.133-.394-.133-.532 0a.36.36 0 0 0-.105.261c0 .578-.458 1.031-1.045 1.031a1.027 1.027 0 0 1-1.045-1.031.35.35 0 0 0-.105-.261.4.4 0 0 0-.527 0 .36.36 0 0 0-.106.261c0 .985.784 1.76 1.783 1.76zM5.543 5.259a.385.385 0 0 0 .55 0 .39.39 0 0 0 0-.55l-.844-.844a.39.39 0 0 0-.55 0 .39.39 0 0 0 0 .55zM9.54 5.373a.39.39 0 0 0 .274-.114l.844-.844a.39.39 0 0 0 0-.55.39.39 0 0 0-.55 0l-.844.844a.39.39 0 0 0 .275.664M7.679 4.887a.39.39 0 0 0 .39-.39v-1.19a.39.39 0 1 0-.78 0v1.19c0 .216.174.39.39.39"
  }))));
};
export default SvgPurchase;